<script lang="ts" context="module">
  import { getStr, globalCurrencyTag } from '../../../../common/util';
  import AtcExtraCareCoatingDetails from './AtcExtraCareCoatingDetails.svelte';
  import AtcExtraCareDetails from './AtcExtraCareDetails.svelte';
  import AtcExtraSetupDetails from './AtcExtraSetupDetails.svelte';
  import AtcExtraSetupServiceDetails from './AtcExtraSetupServiceDetails.svelte';
</script>

<script lang="ts">
  import AtcExtraAppleCareServiceDetails from './AtcExtraAppleCareServiceDetails.svelte';
  import AtcVasDetails from './AtcVasDetails.svelte';

  export let data;
  console.log(data, 'data');
  let displayExtraCareLogo = true;
  let applecareContainerClass = '';

  $: serviceEntries = data?.serviceEntries;
  $: entry = data?.entry;
  $: lmdServiceDisplay =
    entry?.vasEligibleDataList?.indexOf(vasEligibleData => !!vasEligibleData.extraSetupService) > -1;
  $: displayExtraCareLogo =
    entry?.vasEligibleDataList?.indexOf(
      vasEligibleData => !!vasEligibleData.extraCareService || !!vasEligibleData.extraCareCoating
    ) === -1;
  $: processServiceEntries(serviceEntries);

  function processServiceEntries(serviceEntries: any[]) {
    if (!serviceEntries) return;

    serviceEntries.forEach(serviceEntry => {
      if (serviceEntry.vasGroup === 'ACC' && serviceEntry.priceType === 'ACC_PRICE') {
        applecareContainerClass = 'c_vas-details--applecontent';
      }
    });
  }
  function processVasEligibleData(vasEligibleData, index: number, totalItems: number) {
    return {
      coatingClass: vasEligibleData.extraCareCoating
        ? 'extra-care-coating-vas-details'
        : vasEligibleData.combinedVas === true && vasEligibleData.vasPrices?.length > 5
          ? 'js-extra-safecard-essetial-plus-vas-details'
          : ' ',
      lastIndex: index === totalItems - 1 ? 'last-add-to-cart-vas' : ' ',
      isSafeguardService: !(
        vasEligibleData.extraCareService ||
        vasEligibleData.extraCareCoating ||
        vasEligibleData.splitAcService ||
        vasEligibleData.extraSetupService ||
        vasEligibleData.appleCareService
      ),
      isFirstService: index === 0,
    };
  }
  function getLabelDataByCode(servicesBlocks, code) {
    return servicesBlocks.find(x => x.code === code);
  }
</script>

<div id="addToCartService">
  <!-- Moved serviceHeader logic out of forEach -->
  <h1
    data-label-selected-no-plan={getStr('extra.services.cartpopup.care.text')}
    data-label-selected-nothing={getStr('extra.services.cartpopup.stressfree.text')}
    data-label-selected-valid={getStr('extra.services.cartpopup.secure.text')}
    class="service-header no-plan-header"
  >
    <!-- {getStr('extra.services.cartpopup.stressfree.text')} -->
  </h1>

  {#each entry?.vasEligibleDataList as vasEligibleData, index}
    {@const { coatingClass, lastIndex } = processVasEligibleData(
      vasEligibleData,
      index,
      entry?.vasEligibleDataList.length
    )}
    <div
      class="{applecareContainerClass} c_vas-details-content {coatingClass} {lastIndex}"
      class:extra-setup-vas-details={vasEligibleData?.extraSetupService}
    >
      {#if vasEligibleData.extraCareService}
        <AtcExtraCareDetails
          data={vasEligibleData}
          selectedServices={serviceEntries}
          product={entry.product}
          labelData={getLabelDataByCode(entry?.product?.servicesBlocks, 'servicesExtraCarePDPContent')}
        />
      {:else if vasEligibleData.extraCareCoating}
        <AtcExtraCareCoatingDetails
          entry={vasEligibleData}
          selectedServices={serviceEntries}
          product={entry.product}
          parentEntryNumber={entry.entryNumber}
          loopindex={index}
          showLogo={displayExtraCareLogo}
          entryServiceGroupNumber={data?.entryServiceGroupNumber}
        />
      {:else if vasEligibleData.splitAcService}
        <AtcExtraSetupDetails
          productattributes={entry.product.attributeLabels}
          pdpAcSetupFreeSelected={data?.acSetupAddedAsFree}
          selectedServices={serviceEntries}
          entry={vasEligibleData}
          product={entry.product}
          parentEntryNumber={entry.entryNumber}
          childEntries={entry.childEntries}
          entryServiceGroupNumber={data?.entryServiceGroupNumber}
        />
      {:else if vasEligibleData.extraSetupService}
        <AtcExtraSetupServiceDetails
          productattributes={entry.product.attributeLabels}
          entry={vasEligibleData}
          selectedServices={serviceEntries}
          parentEntry={entry}
          product={entry.product}
          parentEntryNumber={entry.entryNumber}
          loopindex={index}
          entryServiceGroupNumber={data?.entryServiceGroupNumber}
        />
      {:else if vasEligibleData.appleCareService}
        <AtcExtraAppleCareServiceDetails
          entry={vasEligibleData}
          selectedServices={serviceEntries}
          product={entry.product}
          parentEntryNumber={entry.entryNumber}
          loopindex={index}
        />
      {:else}
        <AtcVasDetails
          entry={vasEligibleData}
          selectedServices={serviceEntries}
          product={entry.product}
          parentEntryNumber={entry.entryNumber}
          loopindex={index}
        />
      {/if}
    </div>
    <div class="c_vas-details-divider row-flex"></div>
  {/each}

  {#if !lmdServiceDisplay}
    {#if entry?.lmdData?.lmdConfigurations?.length > 0}
      <div class="c_lmd-service">
        <div class="c_lmd-service-title">
          {getStr('addtocart.service.lmd.heading')}
        </div>
        <div class="c_lmd-service-container row-flex">
          {#each entry?.lmdData?.lmdConfigurations as lmdConfiguration, index}
            <div
              data-index={index}
              class="col-flex-xs-12 col-flex-sm-12 col-flex-md-12 c_lmd-service-content js-apply-lmd-service"
            >
              <span class="selected-icon"></span>
              <div class="c_lmd-service-content-info">
                {@html lmdConfiguration.description}
              </div>
              <div class="c_lmd-service-content-price">
                {@html globalCurrencyTag}&nbsp;
                <strong>{lmdConfiguration.price?.formattedValue}</strong>
              </div>
              <form class="lmd-service-form-{index}">
                <input type="hidden" name="productCode_{index}" value={lmdConfiguration.productCode} />
                <input type="hidden" name="parentEntryNumber_{index}" value={entry.entryNumber} />
                <input type="hidden" class="js-lmd-service-group-number" name="serviceGroupNumber_{index}" value="" />
                <input
                  type="hidden"
                  class="{lmdConfiguration.productCode}_entryNumber"
                  name="entryNumber_{index}"
                  value=""
                />
                <input
                  type="hidden"
                  class="{lmdConfiguration.productCode}_entryType"
                  name="entryType_{index}"
                  value={lmdConfiguration.description}
                />
              </form>
            </div>
          {/each}
        </div>
      </div>
    {/if}
  {/if}
</div>
